var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.orderSubmission },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            {
              class: _vm.$style.appGrid,
              attrs: { md12: !_vm.isGuest, md8: _vm.isGuest, xs12: "" }
            },
            [
              _vm.order
                ? _c("DesktopConfirmationMain", {
                    attrs: {
                      "data-fields": _vm.dataFields,
                      "check-id": _vm.checkId
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.isGuest
            ? _c(
                "v-flex",
                { class: _vm.$style.appGrid, attrs: { xs12: "", md4: "" } },
                [_c("DesktopAdv")],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/desktop/components/DesktopConfirmation.vue?vue&type=template&id=1f5cfd1f&
// module id = null
// module chunks = 